import {Paper} from "@mantine/core";
import {NumberInput} from "@mantine/core";
import {Switch} from "@mantine/core";
import {Alert} from "@mantine/core";
import {SegmentedControl} from "@mantine/core";
import React, {useContext, useEffect, useMemo, useState} from "react";
import Icon from "../../components/Icon/Icon.tsx";
import IconMap from "../../components/Icon/IconMap.ts";
import style from './HerdFest.module.css';

const doorState = {
    NONE: 'none',
    OPEN: 'open',
    LOCK: 'locked',
    AIRLOCK: 'airlock',
    UNKOWN: 'unknown'
}
// const COMBAT_ROOM = 1052;


const tiles = {
    none: null,
    f_entrance: 'https://img.swcombine.com//rooms/Overlays/overlay_f-enter.gif',
    command: 'https://img.swcombine.com//rooms/Overlays/overlay_f-cockpit.gif',
    entrance: 'https://img.swcombine.com//rooms/Overlays/overlay_enter.gif',
    storage: 'https://img.swcombine.com//rooms/Overlays/overlay_store.gif',
    pit: 'https://img.swcombine.com//rooms/Overlays/overlay_tamingpit.gif',
    training: 'https://img.swcombine.com//rooms/Overlays/overlay_train.gif',
    medbay: 'https://img.swcombine.com//rooms/Overlays/overlay_medbay.gif',
    infantry: 'https://img.swcombine.com//rooms/Overlays/overlay_infantry.gif',
    dock: 'https://img.swcombine.com//rooms/Overlays/overlay_dock.gif',
    hangar: 'https://img.swcombine.com//rooms/Overlays/overlay_hanger.gif',
}


const NPCS = [
    {name: 'Brol Tarka (Droids and Exotics Vendor, Theft Quest)', type: 'quest', room: 6058},
    {name: 'Captain Irrwit Rontono (Terrorists)', type: 'quest', room: 6057},
    {name: 'Gridduck Maloon (Opera)', type: 'quest', room: 6062},
    {name: 'Jhax Frondherder (Missing Herdship)', type: 'quest', room: 6096},
    {name: 'Jhess Ortall (Translator - Daily)', type: 'daily', room: 6065},
    {name: 'Khalna Critid (Bio Samples - Daily)', type: 'daily', room: 6099},
    {name: 'Liran Garamin (Artist - Daily)', type: 'daily', room: 6095},
    {name: 'Nadar Isfrutus (Tourists)', type: 'quest', room: 6087},
    {name: 'Plorribloom Freaflos (Watering - Daily)', type: 'daily', room: 6063},
    {name: 'Rhym Nasendow (Winter Beacon - Daily)', type: 'daily', room: 6083},
    {name: 'Snai Escabri (Prophecy Tree)', type: 'quest', room: 6082},
    {name: 'Sola Wyndaru (Tourists)', type: 'quest', room: 6088},

    {name: 'Boceta Murray', type: 'opera', room: 6069},
    {name: 'Fenn Creel', type: 'opera', room: 6089},
    {name: 'Fretyln Keiko-sho', type: 'opera', room: 6101},
    {name: 'Janina Navarr', type: 'opera', room: 6077},
    {name: 'Loretta Amavia', type: 'opera', room: 6059},
    {name: 'Montross Gundo', type: 'opera', room: 6087},
    {name: 'Rayf Klivian', type: 'opera', room: 6064},
    {name: 'Renna Quara', type: 'opera', room: 6054, isSuspect: true},
    {name: 'Segedoo Corr', type: 'opera', room: 6078},
    {name: 'Sela Fafnik', type: 'opera', room: 6059},
    {name: 'Shala Poro', type: 'opera', room: 6068, isSuspect: true},
    {name: 'Tormo Shal', type: 'opera', room: 6094, isSuspect: true},

    {name: 'Farno Baar (Fruit Vendor)', type: 'other', room: 6075, isSuspect: true},
    {name: 'Vyna Soli (Herdalife)', type: 'other', room: 6084, isSuspect: true},


    {name: 'Cluw Dats', type: 'merchant', room: 6080, wares: ['Cyborg Skill Card', 'Datapad', 'Faulty Cybernetic', 'Portable Power Generator']},
    {name: 'Dhy\'thoh Eandu', type: 'merchant', room: 6085, wares: ['Bait', 'Droid Parts', 'Healing Stick', 'Ship Parts']},
    {name: 'Ti Zubill', type: 'merchant', room: 6086, wares: ['Antidote', 'GPS', 'Stimpack', 'Sub-Space Radio']},
    {name: 'Wass Sugitrengs', type: 'merchant', room: 6091, wares: ['Biological Sensor Pack', 'Sensor Beacon', 'Toolkit', 'Flamethrower']},
]
const plants = {
    6059: 'Climbing Fern',
    6081: 'Malreaux Rose',
    6082: 'Cloudflower',
    6076: 'Massassi Tree',
    6077: 'Alpin Glowing Lichen',
    6083: 'Yavin Glowing Orchard',
    6084: 'Kwazel Candy',
    6090: 'Manak',
    6089: 'Avedame',
    6094: 'Tchuspera',
    6095: 'Featherfern',
    6088: 'Namana Tree',
    6087: 'Milla Flower',
    6098: 'Zabrak Spine',
    6099: 'Bafforr Tree',
    6100: 'Bachani Flower',
    6101: 'Hoth Cave Lichen',
    6064: 'Poola Blossom',
    6063: 'Ruik',
    6060: 'Anzati Snot Garlic'
}
const plantList = Object.entries(plants).map(([room, name]) => ({room: parseInt(room), name})).sort((a, b) => a.name.localeCompare(b.name));

const Context = React.createContext({});


const views = [
    {value: 'herdship', label: 'Bafforr Jubilee'},
    {value: 'shop', label: 'Shopping List'},
    {value: 'research', label: 'Research Centre'},

]
export default function HerdFest() {
    const [view, setView] = useState('herdship');

    useEffect(() => {
        let view = localStorage.getItem('herdfest_view');
        if (view) {
            setView(view);
        }
    }, []);

    return (

        <div className="page">
            <h1>HerdFest Map</h1>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', marginBottom: '0.5rem'}}>
                <SegmentedControl value={view} onChange={val => {
                    localStorage.setItem('herdfest_view', val);
                    setView(val)
                }} data={views}/>
            </div>

            {view === 'herdship' ? <HerdShip/> : null}
            {view === 'shop' ? <ShopList/> : null}
            {view === 'research' ? <ResearchCenter/> : null}
        </div>
    )
}


const HerdShip = () => {
    const [easyDoors, setEasyDoors] = useState(false);
    const [showOpera, setShowOpera] = useState(true);
    const [showPlants, setShowPlants] = useState(true);
    const [hoverRoom, setHoverRoom] = useState(null);

    return (
        <Context.Provider value={{showOpera, showPlants, hoverRoom}}>
            <Paper shadow="xs" p="md" withBorder className={style.card}>
                <div style={{display: 'flex', flexDirection: 'column'}} className="md:flex-row">
                    <div className={`col flex-grow-0 ${easyDoors ? style.easyDoors : ''}`}>
                        <h6 style={{marginTop: 0}}>Main Floor</h6>
                        <div className={style.floor}>
                            <div className={style.row}>
                                <Blank/>
                                <Room id={6070} right={doorState.OPEN} down={doorState.OPEN}/>
                                <Room id={6071} type="entrance" right={doorState.OPEN}/>
                                <Room id={6072} right={doorState.OPEN}/>
                                <Room id={6073} type="storage" down={doorState.OPEN}/>
                            </div>
                            <div className={style.row}>
                                <Room id={6074} type="storage" right={doorState.OPEN} down={doorState.OPEN}/>
                                <Room id={6075} right={doorState.OPEN} down={doorState.OPEN}/>
                                <Room id={6076} right={doorState.OPEN} down={doorState.OPEN}/>
                                <Room id={6077} right={doorState.OPEN} down={doorState.OPEN}/>
                                <Room id={6078} right={doorState.OPEN} down={doorState.OPEN}/>
                                <Room id={6079} type="storage" down={doorState.OPEN}/>
                            </div>
                            <div className={style.row}>
                                <Room id={6080} down={doorState.OPEN}/>
                                <Room id={6081} down={doorState.OPEN} right={doorState.OPEN}/>
                                <Room id={6082}/>
                                <Room id={6083} right={doorState.OPEN}/>
                                <Room id={6084} down={doorState.OPEN}/>
                                <Room id={6085} down={doorState.OPEN}/>
                            </div>
                            <div className={style.row}>
                                <Room id={6086} down={doorState.OPEN}/>
                                <Room id={6087} down={doorState.OPEN} right={doorState.OPEN}/>
                                <Room id={6088} down={doorState.OPEN}/>
                                <Room id={6089} down={doorState.OPEN} right={doorState.OPEN}/>
                                <Room id={6090} down={doorState.OPEN}/>
                                <Room id={6091} down={doorState.OPEN}/>
                            </div>
                            <div className={style.row}>
                                <Room id={6092} type="storage" right={doorState.OPEN}/>
                                <Room id={6093} right={doorState.OPEN} down={doorState.OPEN}/>
                                <Room id={6094} right={doorState.OPEN}/>
                                <Room id={6095} right={doorState.OPEN}/>
                                <Room id={6096} right={doorState.OPEN} down={doorState.OPEN}/>
                                <Room id={6097} type="pit"/>
                            </div>
                            <div className={style.row}>
                                <Blank/>
                                <Room id={6098} type="medbay" right={doorState.OPEN}/>
                                <Room id={6099} type="medbay" right={doorState.OPEN}/>
                                <Room id={6100} type="medbay" right={doorState.OPEN}/>
                                <Room id={6101} type="medbay"/>
                            </div>
                        </div>
                        <br/>
                        <hr/>
                        <h6>Lower Floor</h6>
                        <div className={style.floor}>
                            <div className={style.row}>
                                <Blank/>
                                <Room id={6054} right={doorState.OPEN} down={doorState.OPEN}/>
                                <Room id={6055} type="medbay" right={doorState.OPEN} down={doorState.OPEN}/>
                                <Room id={6056} right={doorState.OPEN} down={doorState.OPEN}/>
                                <Room id={6057} down={doorState.OPEN}/>
                            </div>
                            <div className={style.row}>
                                <Blank/>
                                <Room id={6058} type="infantry" right={doorState.OPEN} down={doorState.OPEN}/>
                                <Room id={6059}/>
                                <Room id={6060} right={doorState.OPEN}/>
                                <Room id={6061} type="dock" down={doorState.OPEN}/>
                            </div>
                            <div className={style.row}>
                                <Blank/>
                                <Room id={6062} type="training" right={doorState.OPEN} down={doorState.OPEN}/>
                                <Room id={6063} down={doorState.OPEN}/>
                                <Room id={6064} right={doorState.OPEN} down={doorState.OPEN}/>
                                <Room id={6065} type="hangar" down={doorState.OPEN}/>
                            </div>
                            <div className={style.row}>
                                <Blank/>
                                <Room id={6066} right={doorState.OPEN}/>
                                <Room id={6067} type="medbay" right={doorState.OPEN}/>
                                <Room id={6068} right={doorState.OPEN}/>
                                <Room id={6069}/>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <Alert color="blue">The concert location is higlighted in blue on the map</Alert>
                        <div style={{display: 'flex', flexDirection: 'column'}} className="md:flex-row">
                            <div className="col">
                                <h4>Settings</h4>
                                <div style={{marginBottom: '0.5rem'}}>
                                    <Switch id="easyDoors" checked={easyDoors} onChange={e => setEasyDoors(e.currentTarget.checked)} style={{marginRight: '0.5rem'}} label="Easy Doors"/>
                                </div>

                                <div style={{marginBottom: '0.5rem'}}>
                                    <Switch id="showOpera" checked={showOpera} onChange={e => setShowOpera(e.currentTarget.checked)} style={{marginRight: '0.5rem'}} label="Show Opera NPCs"/>
                                </div>
                                <div style={{marginBottom: '0.5rem'}}>
                                    <Switch id="showPlants" checked={showPlants} onChange={e => setShowPlants(e.currentTarget.checked)} style={{marginRight: '0.5rem'}} label="Show Plants"/>
                                </div>
                                <hr/>
                                <div className={showPlants ? '' : 'hidden md:block'}>
                                    <h4>Plants</h4>
                                    {plantList.map(p => <PlantRow key={p.room} plant={p} onHover={setHoverRoom}/>)}
                                </div>
                            </div>
                            <div className="col">
                                <h4>NPCs</h4>
                                {NPCS.filter(n => n.type !== 'merchant').map(n => <NPCRow key={n.name} npc={n} onHover={setHoverRoom} showOpera={showOpera}/>)}
                            </div>
                        </div>
                        <h4>NPC Shops</h4>
                        <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
                            {NPCS.filter(n => n.type === 'merchant').map(n => <Merchant key={n.room} npc={n} onHover={setHoverRoom}/>)}
                        </div>
                    </div>
                </div>
            </Paper>
        </Context.Provider>);
}

const capitalize = str => str.charAt(0).toUpperCase() + str.substring(1);

const NPCRow = ({npc, onHover, showOpera}) => {
    let title = npc.wares ? npc.wares.join('\n') : null;
    let suspect = npc.isSuspect ? <Icon className="ml-1" icon={IconMap.HerdSuspect} color="#4370d2" title="Theft Suspect"/> : null;
    return <div className={`flex-row align-items-center ${showOpera || npc.type !== 'opera' ? 'flex' : 'hidden md:flex'}`} style={{marginBottom: '0.25rem'}}
                onMouseEnter={() => onHover(npc.room)} onMouseLeave={() => onHover(null)} title={title}><NPCIcon
        type={npc.type} name={capitalize(npc.type)}/> {npc.name} {suspect}</div>
}
const PlantRow = ({plant, onHover}) => {
    return <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.25rem'}} onMouseEnter={() => onHover(plant.room)} onMouseLeave={() => onHover(null)}><IconBack><Icon
        icon={IconMap.HerdPlant} color="#00aa00" title="Plant"/></IconBack> {plant.name}</div>
}
const Merchant = ({npc, onHover}) => {
    return <div className={`col ${style.shopList}`} onMouseEnter={() => onHover(npc.room)} onMouseLeave={() => onHover(null)}>
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}><NPCIcon type={npc.type} name="Shop"/> <b>{npc.name}</b></div>
        {npc.wares.map(w => <div key={w}>{w}</div>)}</div>;
}

const areaColors = [
    'transparent',
    '#4CB140',
    '#C9190B',
    '#EC7A08',//'#EF9234',
    '#F4C145',//'#F6D173',
    '#5752D1',
    '#218500',
    '#6100fd'
]


const Room = ({
    id,
    type = 'normal',
    right = doorState.NONE,
    down = doorState.NONE,
    area = 0,
    path = false,
    combat = false,
    text = null,
    width = 1,
}) => {
    const {showOpera, showPlants, hoverRoom} = useContext(Context);
    const ns = useMemo(() => {
        return NPCS.filter(n => n.room === id && (n.type !== 'opera' || showOpera))
    }, [showOpera]);
    return (
        <div className={`${style.room} width-${width}`}>
            {area > 0 ? <div className={style.area} style={{backgroundColor: areaColors[area]}}/> : null}
            {type !== 'normal' ? <img className={style.roomOverlay} src={tiles[type]}/> : null}
            {right !== doorState.NONE ? <div className={`${style.doorRight} ${right}`}/> : null}
            {down !== doorState.NONE ? <div className={`${style.doorDown} ${down}`}/> : null}
            {hoverRoom === id ? <div className={style.highlight}/> : null}
            {id === 6061 ? <div className={style.concert} title="Concert hall"/> : null}
            {combat ? <div className={style.combat} title="Current fighting"/> : null}
            {path ? <div className={style.path} style={{backgroundColor: areaColors[area]}}/> : null}
            {text ? <div className={style.text}>{text}</div> : null}

            <div className={style.roomContent}>
                {showPlants && plants[id] ? <Plant name={plants[id]}/> : ''}
                {ns.map(n => <NPCIcon key={n.name} type={n.type} name={n.name}/>)}
            </div>
        </div>
    )
}
const Blank = () => <div className={style.roomBlank}/>

const NPCIcon = ({type, name}) => {
    let icon = IconMap.HerdNpc;
    let color = '#db67e3';

    switch (type) {
        case 'daily':
            color = '#ffff00';
            icon = IconMap.HerdDaily;
            break;
        case 'quest':
            color = '#ff8800';
            icon = IconMap.HerdQuest;
            break;
        case 'merchant':
            color = '#ff2800';
            icon = IconMap.HerdShop;
            break;
        case 'opera':
            color = '#4370d2';
            icon = IconMap.HerdOpera;
            break;
    }
    return <IconBack><Icon icon={icon} title={name} color={color}/></IconBack>
}

const Plant = ({name}) => {
    return <IconBack><Icon icon={IconMap.HerdPlant} color="#00aa00" title={name}/></IconBack>
}

const IconBack = ({children}) => <div className={style.iconBack}>{children}</div>;

// const timestamp = CGT.fromMillis(import.meta.env.BUILD_TIMESTAMP);


const ResearchCenter = () => {
    return (
        <Paper shadow="xs" p="md" withBorder className={`${style.card} ${style.reserchCentre}`}>
            <div style={{display: 'flex', flexDirection: 'column'}} className="md:flex-row">
                <img src="/gasteroid%20crater.jpg" alt="" style={{maxHeight: '80vh', maxWidth: '100%', margin: '0 auto'}}/>
            </div>
        </Paper>
    )
}

const prizes = [
    {id: 'plant', label: 'Any plant', type: 'plant', cost: 1},
    {id: 'lothcat', label: 'Loth-Cat Egg', type: 'creature', cost: 10},
    {id: 'gundark', label: 'Gundark Egg', type: 'creature', cost: 350},
    {id: 'mudhorn', label: 'Mudhorn Egg', type: 'creature', cost: 350},
    {id: 'ronto', label: 'Ronto Egg', type: 'creature', cost: 250},
    {id: 'iso', label: 'ISO-5R DC', type: 'droid', cost: 20},
    {id: 'camdroid', label: 'Hologlide J57 Cam Droid DC', type: 'droid', cost: 30},
    {id: 'camaran', label: 'Oeavvor Jet Catamaran DC', type: 'vehicle', cost: 40},
    {id: 'aurorient', label: 'Aurorient Express DC', type: 'vehicle', cost: 75},
    {id: 'gale', label: 'Gale-class StarStage Light Freighter DC', type: 'ship', cost: 100},
    {id: 'mantis', label: 'D5-Mantis Patrol Craft DC', type: 'ship', cost: 125},
    {id: 'dynamic', label: 'Dynamic-class Freighter DC', type: 'ship', cost: 250},
    {id: 'herdship', label: 'Ithorian Herdship DC', type: 'ship', cost: 650},
    {id: 'plushie', label: 'HerdFest Commemorative Plushie', type: 'plushie', cost: 5}
];


const ShopList = () => {
    const [leaves, setLeaves] = useState(null);
    const [list, setList] = useState({});

    const [available, spent] = useMemo(() => {
        const s = prizes.reduce((acc, entity) => acc + (entity.cost * (list[entity.id] ?? 0)), 0);
        const a = leaves - s;
        return [a, s];
    }, [leaves, list]);

    useEffect(() => {
        let view = localStorage.getItem('herdfest_shop_tot');
        let list = localStorage.getItem('herdfest_shop_list');
        if (view) {
            setLeaves(view);
        }
        if (list) {
            setList(JSON.parse(list));
        }
    }, []);


    return (
        <Paper shadow="xs" p="md" withBorder>
            <h2>Leaves</h2>
            <div style={{display: 'flex'}}>
                <div className="col">
                    <b>Currently Available</b><br/>
                    <NumberInput style={{width: 80}} value={leaves} onChange={val => {
                        localStorage.setItem('herdfest_shop_tot', val.toString());
                        setLeaves(val);
                    }} autoFocus={true} min={0}/>
                </div>
                <div className="col">
                    <b>Spent</b><br/>
                    <NumberInput readOnly value={spent} style={{width: 80}}/>
                </div>
                <div className="col">
                    <b>Leftover</b><br/>
                    <NumberInput readOnly value={available} style={{width: 80}} error={available<0}/>
                </div>
            </div>
            <p><i>Your device will remember the values you put in. No data is being collected and will not be shared between different devices.</i></p>
            <div style={{width: '100%'}}>
                <div style={{fontWeight: 'bold'}}>
                    <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
                        <div className="col-8 md:col-4">Entity</div>
                        <div className="col-4 md:col-2" style={{textAlign: 'right'}}>Cost</div>
                        <div className="col-6 md:col-2">Number</div>
                        <div className="col-2 md:col-2" style={{textAlign: 'right'}}>Can Afford</div>
                        <div className="col-4 md:col-2" style={{textAlign: 'right'}}>Total Cost</div>
                    </div>
                </div>
                {prizes.map(entity => <ShopRow key={entity.id} entity={entity} num={list[entity.id]} available={available} onChange={setList}/>)}
            </div>
        </Paper>

    )

}
const ShopRow = ({entity, num, available, onChange}) => {
    const max = Math.max((num ?? 0) + Math.floor(available / entity.cost), 0);
    return (
        <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center'}}>
            <div className="md:col-4 col-8">
                <div style={{display: 'flex', alignItems: 'center'}}><PrizeIcon type={entity.type}/>
                    <div>{entity.label}</div>
                </div>
            </div>
            <div className="md:col-2 col-4" style={{textAlign: 'right'}}>{entity.cost}</div>
            <div className="md:col-2 col-6">
                <NumberInput
                    style={{width: 80}}
                    value={num ?? ''}
                    onChange={val => onChange(prev => {
                        let next = {...prev};
                        if (val > max) {
                            next[entity.id] = max;
                        } else {
                            next[entity.id] = val;
                        }
                        localStorage.setItem('herdfest_shop_list', JSON.stringify(next));
                        return next;
                    })}
                    min={0}
                    max={max}/>
            </div>
            <div className="md:col-2 col-2" style={{textAlign: 'right'}}>{max}</div>
            <div className="md:col-2 col-4" style={{textAlign: 'right'}}>{entity.cost * (num ?? 0)}</div>
        </div>
    )
}

const prizeIconMap = {
    plant: {icon: IconMap.HerdPlant, color: '#00aa00'},
    ship: {icon: IconMap.Ship, color: '#2424a4'},
    vehicle: {icon: IconMap.Vehicle, color: '#960c0c'},
    droid: {icon: IconMap.Datacard, color: '#c8c8c8'},
    plushie: {icon: IconMap.HerdDoll, color: '#95099a'},
    creature: {icon: IconMap.HerdCat, color: '#703a0f'},
}

const PrizeIcon = ({type}) => {
    const i = prizeIconMap[type];
    if (i) {
        return <Icon icon={i.icon} color={i.color} size={"24"} style={{marginRight: '0.5rem'}}/>
    } else {
        return null;
    }
}
